export const SWITCH_BOTTOM_PANEL_ASSET = 'switch_bottom_panel_asset';
export const COLLAPSE_BOTTOM_PANEL = 'collapse_bottom_panel';
export const FULLSCREEN_BOTTOM_PANEL = 'fullscreen_bottom_panel';

export const EXPAND_BOTTOM_PANEL = 'expand_bottom_panel';
export const SWITCH_ACCOUNT_TYPE = 'switch_account_type';
